
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(1972|4075)$/.test(chunkId);
},
rootOutputDir: "",

    };
}
